import { useEffect, useRef, useState } from 'react';

const useScreenWidth = () => {
  const [screenWidth, setScreenWidth] = useState(Infinity);
  const observer = useRef<ResizeObserver | void>();

  useEffect(() => {
    if (!observer.current) {
      // acknowledgement: https://stackoverflow.com/a/69196265
      observer.current = new ResizeObserver(() => {
        setScreenWidth(document.body.clientWidth);
      }).observe(document.body);
    }

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  return { screenWidth };
};

export default useScreenWidth;
